import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Inairthreshold from '../entities/inairthreshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface InairthresholdState extends ListState<Inairthreshold>{
    editInairthreshold:Inairthreshold
}
class UserMutations extends ListMutations<Inairthreshold>{

}
class InairthresholdModule extends ListModule<InairthresholdState,any,Inairthreshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Inairthreshold>(),
        loading:false,
        editInairthreshold:new Inairthreshold()
    }
    actions={
        async getPage(context:ActionContext<InairthresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Inairthreshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairthreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<InairthresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/Inairthreshold/Create',payload.data);
        },
        async update(context:ActionContext<InairthresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/Inairthreshold/Update',payload.data);
        },
        async delete(context:ActionContext<InairthresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/Inairthreshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<InairthresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Inairthreshold/GetById?Id='+payload.id);
            return reponse.data.result as Inairthreshold;
        },
        async RegetAll(context:ActionContext<InairthresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Inairthreshold/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairthreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
    };
    mutations={
        setCurrentPage(state:InairthresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:InairthresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:InairthresholdState,inairthreshold:Inairthreshold){
            
            state.editInairthreshold=inairthreshold;
            //console.log(state.editFloor);
        }
    }
}
const inairthresholdModule=new InairthresholdModule();
export default inairthresholdModule;